import { Model } from '@vuex-orm/core';
import { ScopeConfiguration } from './ScopeConfiguration';
import { ScopeProfile } from './ScopeProfile';
import { OPTIONS } from './ScopeConfiguration';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export const TYPES = {
  MARKTPLAATS: 'marktplaats',
  PRAKTISCHE_HULP: 'praktische-hulp'
};

export const ROLES = {
  CLIENT: 'Client',
  VOLUNTEER: 'Vrijwilliger',
  BOTH: 'Default'
};

export class Scope extends Model {
  static entity = 'scopes'

  static primaryKey = 'key'

  static fields () {
    return {
      id: this.attr(null),
      key: this.attr(null),
      type: this.attr(null),
      role: this.attr(null),
      configuration: this.hasOne(ScopeConfiguration, 'scope_key'),
      profile: this.hasOne(ScopeProfile, 'scope_key')
    };
  }

  async setProfile (profile) {
    this.profile = await ScopeProfile.create({
      data: profile
    });
  }

  isOptionEnabled (option) {
    return this.configuration.opties[option];
  }

  get canCreateAanbod () {
    return this.role !== ROLES.CLIENT;
  }

  get canCreateVraag () {
    return this.role !== ROLES.VOLUNTEER;
  }

  get typeIsMarktplaats () {
    return this.type === TYPES.MARKTPLAATS;
  }

  get typeIsPraktischeHulp () {
    return this.type === TYPES.PRAKTISCHE_HULP;
  }

  get roleIsClient () {
    return this.role === ROLES.CLIENT;
  }

  get roleIsVolunteer () {
    return this.role === ROLES.VOLUNTEER;
  }

  get isRoutingEnabled () {
    return this.role === ROLES.CLIENT && this.configuration.opties[OPTIONS.ROUTERING_AANMELDING_VRAGER] ||
           this.role === ROLES.VOLUNTEER && this.configuration.opties[OPTIONS.ROUTERING_AANMELDING_VRIJWILLIGER];
  }
}
